/* eslint-disable react/react-in-jsx-scope */
import { Redirect } from 'react-router-dom';

const Error404 = () => (<Redirect to="/home" />);

export default Error404;
